import { FunctionComponent } from 'react';
type ErrorInputProps = {
  id?: string;
  error?: string;
};
const ErrorInput: FunctionComponent<ErrorInputProps> = ({ error, id }) => {
  return error ? (
    <p data-testid={'error-' + (id || 'selector')} className="text-xs text-danger">
      {error}
    </p>
  ) : null;
};

export default ErrorInput;
